import React from 'react';
import ReactDOM from 'react-dom/client';
import './i18n/config';
import App from './App';
import './index.css';
import { initGoogleAnalytics } from './utils/analytics';

initGoogleAnalytics();

const root = ReactDOM.createRoot(
  document.getElementById('root') as HTMLElement
);
root.render(
  <React.StrictMode>
    <App />
  </React.StrictMode>
);
